<template>
  <van-popup 
    class="age-month" 
    v-model="wrapshow" 
    style="border-radius: 20px 20px 0px 0px;"
    position="bottom">
    <van-picker 
      show-toolbar 
      :title="title" 
      :columns="columns"
      @confirm="confirm" 
      @cancel="close" />
  </van-popup>
</template>

<script>


export default {
  name: 'ageMonthPicker',
  data() {
    return {
      wrapshow: true,
      title: "年龄选择",
      maxAge: 99,
      minAge: 0,
      ageIdx: 0,
      monthIdx: 0,
    };
  },
  computed: {
    columns () {
      let { ageIdx, monthIdx, minAge, maxAge } = this;
      let ageColumn = {
        values: new Array(maxAge - minAge).fill().map((v,idx)=>((idx+minAge)+'岁')),
        defaultIndex: ageIdx - minAge,
      };
      let monthColumn = {
        values: new Array(12).fill().map((v,idx)=>idx+'月'),
        defaultIndex: monthIdx,
      };

      return [ageColumn, monthColumn]
    }
  },
  methods: {
    showPicker(opts) {
      // 还原参数
      Object.assign(this, {maxAge: 99,minAge: 0,ageIdx: 0,monthIdx: 0})
      
      return new Promise((resolve) => {
        this.wrapshow = true;
        if (opts) {
          Object.assign(this, opts)
        } 
        this._resolve = resolve;
      });
    },
    close() {
      this.wrapshow = false;
    },
    confirm(v) {
      this.close();
      this._resolve({
        age: Number(v[0].replace("岁", "")),
        month: Number(v[1].replace("月", ""))
      });
    },
  }
};
</script>

